import React from 'react';
import { ErrorState } from '../../../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../../../CommonComponents/OPL/Box/Box';
import { UnrealizedGainLossDetailsSkeleton } from './UnrealizedGainLossDetailsSkeleton';

interface Props {
  title: string;
  onRetry?(): void;
}

export const UnrealizedGainLossDetailsError = ({ title, onRetry }: Props) => {
  return (
    <UnrealizedGainLossDetailsSkeleton title={title}>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </UnrealizedGainLossDetailsSkeleton>
  );
};
